<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Editar Anotação' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <div class="gradient-extendido"></div>
    <ion-card>
      <ion-card-title>{{titulo}}</ion-card-title>
      <ion-textarea rows="8" type="text" formControlName="anotacao" placeholder="Digite sua anotação aqui..."></ion-textarea>
    </ion-card>
    <div class="validation-errors ion-margin-start">
      <ng-container *ngFor="let validation of validation_messages.anotacao">
        <div
          class="error-message ion-padding-start"
          *ngIf="validations_form.get('anotacao')?.hasError(validation.type) && (validations_form.get('anotacao')?.dirty || validations_form.get('anotacao')?.touched)"
        >
          {{ validation.message }}
        </div>
      </ng-container>
    </div>
  </form>
</ion-content>

<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          class="btn-success"
          expand="block"
          type="submit"
          [disabled]="!validations_form.valid"
          (click)="onSubmit(validations_form.value)"
        >
          {{'Salvar' | translate}}
          <i class="fa-solid fa-arrow-right edit"></i>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
